import { ReactNode, useCallback, useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useAppContext } from 'src/contexts/AppContext';
import { TicketGroupEditContext } from 'src/modals/PurchaseWizard/PurchaseWizard.types';
import { PurchaseDeeplinkQueryParam } from 'src/utils/constants/constants';
import { getDeepLinkIdFromUrl } from 'src/utils/deepLinkUtils';
import { newBigIntId } from 'src/utils/idUtils';
import { posChangedField } from 'src/utils/posFieldUtils';
import {
  PurchaseOrderDetailsInput,
  splitOutTicketGroupId,
} from 'src/utils/purchaseUtils';

import { MultiplePurchaseWizardBody } from './MultiplePurchaseWizardBody';
import { MultiplePurchaseWizardProvider } from './MultiplePurchaseWizardContext';
import { createDefaultPoValues } from './utils/createDefaultValues';

export interface PurchaseOrderFormDataType {
  purchaseOrders: PurchaseOrderDetailsInput[];
}

export const MultiplePurchaseWizard = () => {
  const idParam = getDeepLinkIdFromUrl(
    PurchaseDeeplinkQueryParam,
    window.location.href
  );
  const { ticketGroupId, ticketGroupEditReason, ticketGroupEditContext } =
    useMemo(() => {
      return splitOutTicketGroupId(idParam);
    }, [idParam]);

  return (
    <PurchaseOrderDetailsForm
      highlightTicketGroupIds={
        ticketGroupId != null ? [ticketGroupId] : undefined
      }
      initialTicketGroupEditContext={{
        editIntention: ticketGroupEditReason,
        ...ticketGroupEditContext,
      }}
    />
  );
};

const PurchaseOrderDetailsForm = ({
  ...rest
}: {
  highlightTicketGroupIds?: number[];
  initialTicketGroupEditContext?: Partial<TicketGroupEditContext>;
}) => {
  const { loginContext, activeAccountUserId, activeAccountWebClientConfig } =
    useAppContext();

  const defaultValues = createDefaultPoValues({
    activeAccountUserId,
    loginContext,
  });

  const defaultPo = defaultValues ? [defaultValues] : [];
  const methods = useForm<PurchaseOrderFormDataType>({
    defaultValues: {
      purchaseOrders: {
        ...defaultPo,
      },
    },
  });

  return (
    <FormProvider {...methods}>
      <MultiplePurchaseWizardProvider>
        <MultiplePurchaseWizardBody {...methods} {...rest} />
      </MultiplePurchaseWizardProvider>
    </FormProvider>
  );
};
